export enum Breakpoint {
  XXSmall = 400,
  XSmall = 600,
  Small = 717,
  Medium = 878,
  Large = 937,
}
